<template>
  <div class="form-group">
    <label>Cadastro módulo CS</label>
    <div class="col-md-12">
      <div class="row align-items-start">
        <div class="col-md-12 module_cs_wrap">
          <div v-for="(item, index) in modules" :key="index">
            <label for="" class="mb-0"
              >{{ index + 1 }} - Modulos CS instalados / Lacres</label
            >

            <div class="row align-items-center">
              <div class="col-md-6 mb-2">
                <div class="row pl-1 pr-1">
                  <b-input
                    type="text"
                    placeholder="Modulo CS Instalado"
                    name="installed_cs_module[]"
                    v-model="$attrs.value.installed_cs_module[index]"
                    v-on:input="$emit('input', $attrs.value)"
                    v-bind:value="$attrs.value.installed_cs_module[index]"
                  />
                </div>
              </div>
              <div class="col-md-6 mb-2">
                <div class="row justify-content-between pl-1 pr-1">
                  <b-input
                    type="text"
                    placeholder="TLI"
                    name="tli[]"
                    v-model="$attrs.value.tli[index]"
                    v-on:input="$emit('input', $attrs.value)"
                    v-bind:value="$attrs.value.tli[index]"
                  />
                  <button
                    v-if="index"
                    class="btn btn-danger mt-1 btn-sm"
                    type="button"
                    style="width: 100%"
                    @click="removeField(index)"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <button
              style="width: 100%"
              type="button"
              class="btn btn-sm btn-info"
              @click="addField"
            >
              Adicionar campo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "module-cs",
  data() {
    return {
      modules: 1,
    };
  },
  methods: {
    removeField(index) {
      this.$attrs.value.installed_cs_module.splice(index, 1);
      this.$attrs.value.tli.splice(index, 1);
      this.modules--;
    },
    addField() {
      this.modules++;
    },
  },
};
</script>

<style lang="scss" scoped></style>
